module.exports = __webpack_public_path__ + "img/9788958285335.fd8c495b.jpg";